export default "__VITE_ASSET__CsM8s5Lp__"